export const KycStatus = Object.freeze({
    PENDING: 'Pending',
    VERIFIED: 'Verified',
    REJECTED: 'Rejected',
    MANUAL_VERIFICATION_REQUIRED: 'ManualVerificationRequired'
});